import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import useForm from '../utils/useForm';

const useDetailsForm = (onSubmit, values) => {
  const { t } = useTranslation();

  const fields = useMemo(
    () => [
      {
        title: t('AddOrEditPage.AddOrEditLoan.Sections.Details.Details'),
        isTitleHidden: false,
        fields: [
          {
            title: t('common.forms.labels.Lender'),
            name: '_lender.name',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Loan number'),
            name: 'pixel_loan_number',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Close date'),
            name: 'close_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Maturity date'),
            name: 'maturity_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Payment due day'),
            name: 'payment_due_day',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Rate type'),
            name: 'rate_type',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Starting principal balance'),
            name: 'original_principal',
            type: 'currency',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Rate'),
            name: 'rate',
            type: 'percentage',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.DOT Recording Number'),
            name: 'recording_number',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.DOT Recording Date'),
            name: 'recording_date',
            format: !values?.recording_date ? () => 'n/a' : null,
            type: !values?.recording_date ? 'text' : 'date',
            readOnly: true,
          },
        ],
      },
    ],
    [t, values?.recording_date]
  );

  return useForm({ fields, onSubmit, values });
};

export default useDetailsForm;
